<template>
    <div style="padding: 20px 0px 0px 20px;">

        <el-form style="display: flex;flex-wrap: wrap;">
              <!-- <el-form-item label="成单状态:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择成单状态" v-model="input1" style="width: 100%" clearable filterable>
                      <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.id" :label="item.name"></el-option>
                  </el-select>
              </el-form-item> -->


              <el-form-item label="提交人:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择提交人" v-model="input2" style="width: 100%" clearable filterable>
                      <el-option   v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                  </el-select>
              </el-form-item>


              <el-form-item label="学生姓名:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择学生姓名" v-model="input3" style="width: 100%" clearable filterable>
                      <el-option   v-for="item in optionList3"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                  </el-select>
              </el-form-item>

              <el-form-item label="审批状态:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择审批状态" v-model="input4" style="width: 100%" clearable filterable>
                      <el-option   v-for="item in optionList4"  :key="item.id"  :value="item.id" :label="item.name"></el-option>
                  </el-select>
              </el-form-item>

              <el-form-item label="所在地域:"  style="display: flex;width: 33%;">
                    <el-select v-model="input5" clearable filterable placeholder="请选择所在地域"  style="width: 100%;">
                    <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                    :value="item.dictType"></el-option>
                    </el-select>
              </el-form-item>



              <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
              </div>

          </el-form>


          <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="400">
              <el-table-column prop="customerStudent" label="学生姓名" show-overflow-tooltip></el-table-column>
              <!-- <el-table-column prop="orderStatus" label="成单状态" show-overflow-tooltip>
                <template slot-scope="scope">
                      <div v-if="scope.row.orderStatus === 1">已成单</div>
                      <div v-if="scope.row.orderStatus === 2">未成单</div>
                </template>
              </el-table-column> -->
              <el-table-column prop="regionName" label="所在地域" width="100">
              </el-table-column>
              <el-table-column prop="customerIsallpay" label="收款状态" show-overflow-tooltip>
                <template slot-scope="scope">
                      <div v-if="scope.row.customerIsallpay === 1">全款</div>
                      <div v-if="scope.row.customerIsallpay === 2">分期</div>
                </template>
              </el-table-column>
              <el-table-column prop="customerTeacherid" label="老师" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{
                    scope.row.customerTeacherid === 1
                    ? "小单老师"
                    : scope.row.customerTeacherid === 2
                      ? "大单老师"
                      : scope.row.customerTeacherid === 3
                        ? "刘老师"
                        : scope.row.customerTeacherid === 4
                          ? "杨老师"
                          : ""
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="commitName" label="提交人" show-overflow-tooltip width="110"></el-table-column>
              <el-table-column prop="auditStatus" label="审批状态" show-overflow-tooltip>
                <template slot-scope="scope">
                      <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);" v-if="scope.row.auditStatus === 0">待审批</div>
                      <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);" v-if="scope.row.auditStatus === 1">驳回</div>
                      <div style="display: flex;justify-content: space-around;color:rgb(23 226 31);" v-if="scope.row.auditStatus === 2">已完成</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="200">
                  <template slot-scope="scope">
                      <div style="display: flex;justify-content: space-around;">
                          <el-button type="text" :style="{
                            color: scope.row.auditStatus === 2 || scope.row.auditStatus === 1 ? 'rgb(176 180 182)' : '#00aaff'
                          }" :disabled="scope.row.auditStatus === 2 || scope.row.auditStatus === 1" @click="handleClickView('审批', scope.row)">审批</el-button>
                          <el-button type="text" :style="{ color: scope.row.auditStatus === 2 || scope.row.auditStatus === 1 ? 'rgb(176 180 182)' : '#00aaff' }"  :disabled="scope.row.auditStatus === 2 || scope.row.auditStatus === 1" @click="handleClickView('编辑', scope.row)">编辑</el-button>
                          <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>
                      </div>
                  </template>
              </el-table-column>
          </el-table>

          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="pageNum" :page-size="pageSize"
              layout="prev, pager, next,sizes, jumper" :total="total">
          </el-pagination>


          <orderOrderDetailComponents ref="OrderDetail" v-if="orderDetailComponentsShow" :orderFormComponentsType="orderFormComponentsType" :orderFormComponentsID="orderFormComponentsID" @handleEventColes="handleEventColes"></orderOrderDetailComponents>
          <orderOrderUpdateComponents ref="OrderUpdate" v-if="orderUpdateComponentsShow" :orderFormComponentsType="orderFormComponentsType" :orderFormComponentsID="orderFormComponentsID" @handleEventCole="handleEventCole"></orderOrderUpdateComponents>

    </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import orderOrderDetailComponents from './OrderDetail.vue'
import orderOrderUpdateComponents from './OrderUpdate.vue'
import { handleStudent, handleTeacher } from "../utils/publicInterface";
import { getStudentsType } from "@/api/fiveClassApi"


export default {
    components:{
        orderOrderDetailComponents,
        orderOrderUpdateComponents
    },
    data() {
       return{



            orderDetailComponentsShow: false,
            orderUpdateComponentsShow: false,
            orderFormComponentsID:'',
            orderFormComponentsType:'',


            optionList1:[{id:1,name:'已成单'},{id:2,name:'未成单'}],
            optionList2:[],
            optionList3:[],
            optionList4:[{id:0,name:'待审批'},{id:1,name:'驳回'},{id:2,name:'已完成'}],

            input1:'',
            input2:'',
            input3:'',
            input4:'',

            dataList:[],

            pageNum: 1,
            pageSize: 10,
            total: 0,

            input5:'',
            optionsListt:[
                {dictValue:"北京", dictType:1 },
                {dictValue:"深圳", dictType:2 },
            ],

       }
    },

    mounted(){


        axios.get(`${ apiBaseUrl }/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res)=>{ this.optionList2 = res.data.data  })
        getStudentsType(2).then(res => {
            let data = res.data
            getStudentsType(1).then(_res => {
                 this.optionList3 = [...data,..._res.data]
            })
        })

        this.getApiList()


        setInterval(()=>{
          this.getApiList()
        },3000)


        axios.get(`${ apiBaseUrl }/dict//getDictionary/${'地域'} `,
        { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
        }).then((res)=>{ this.optionsListt = res.data.data})
    },


    methods:{

        getApiList(){
            let data = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                commitId: this.input2,
                customerStudent: this.input3,
                auditStatus: this.input4,
                regionName:this.input5 || localStorage.getItem('cityTepy'),
            }
            axios.post(`${apiBaseUrl}/orderCustomerAudit/find`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {

                  if(res.data.code === 200){

                    let data = res.data.data
                    this.dataList = data.records
                    this.pageNum = data.current ? data.current : 0
                    this.pageSize = data.size ? data.size : 10
                    this.total = data.total ? data.total : 0

                    // this.$message({ message: res.data.message, type: "success" })
                  }
            }).catch((err)=>{
                this.$message({ message: err , type: "error" })
            })
        },

        searchBtns(){
            this.getApiList()
        },

        clearBtns(){
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.input4 = ''
            this.input5 = ''
            this.getApiList()
        },

        handleSizeChange(e){
            this.pagepageSizeNum = e
            this.getApiList()
        },

        handleCurrentChange(e){
            this.pageNum = e
            this.getApiList()
        },

        handleClickView(type,itme){
            this.orderFormComponentsType = type
            this.orderFormComponentsID = itme.customerId



            if(this.orderFormComponentsType === '编辑'){
                this.orderUpdateComponentsShow = true
                this.$nextTick(() => {
                    this.$refs.OrderUpdate.init(itme.id)
                })
            }

            if(this.orderFormComponentsType === '审批' || this.orderFormComponentsType === '详情'){
                this.orderDetailComponentsShow = true
                this.$nextTick(() => {
                    this.$refs.OrderDetail.orderCustomerAudit(itme.id)
                })
            }
        },

        handleEventColes(event){
            this.orderDetailComponentsShow = event
            this.getApiList()
        },

        handleEventCole(event){
            this.orderUpdateComponentsShow = event
        },

    }

}
</script>


<style scoped lang="less">

    .no-click {
       pointer-events: none;
    }

    .btns{
        background-color: #428BCA;
        border-color: #428BCA;
        color: #fff;
    }


</style>



// WEBPACK FOOTER //
// src/ApprovalManagement/OrderAmountApproval.vue